import {
  ADD_FAV_PRICE,
  DELETE_FAV_PRICE,
  FETCH_HISORIC_DATA,
  SET_COIN_ICONS,
  SET_DARK_MODE,
  SET_FRESHCHAT_UNREAD_COUNT,
  SET_IS_USING_MOBILE_APP,
  SET_LOGIN_ID,
  SET_MOBILE_TAB,
  SET_REFERRAL,
  SET_SELECTED_COIN,
  SET_TOKEN,
  SET_TOKEN_STATUS,
  SET_UPI_TRANSACTION_DATA,
  SET_USER_PROFILE,
  SHOW_REFRESH_PAGE_POPUP,
  UPDATE_ORDERS,
  SET_IGNORE_MOBILE_APP,
  SET_INNOVATION_DO_NOT_SHOW,
  SET_ACC_POPUP,
} from "./types";

const initialState = {
  PRICES: {},
  REFRESH_ORDER: null,
  HISTORIC_DATA: null,
  FAV_PRICES: [],
  MOBILE_TAB: 1,
  DARK_MODE: true,
  SELECTED_COIN: "BTC",
  TOKEN: null,
  TOKEN_STATUS: null,
  LOGIN_ID: null,
  FRESHCHAT_UNREAD_COUNT: 0,
  UPI_TRANSACTION_DATA: {},
  COIN_ICONS: {},
  REFRESH_PAGE_POPUP: null,
  IS_USING_MOBILE_APP: false,
  IGNORE_MOBILE_APP: false,
  USER_PROFILE: {},
  REFERRAL: "",
  INNOVATION_DNS: {},
  ACC_POPUP: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DARK_MODE:
      return {
        ...state,
        DARK_MODE: true,
      };
    case SET_USER_PROFILE:
      return {
        ...state,
        USER_PROFILE: action.payload,
      };
    case SET_IS_USING_MOBILE_APP:
      return {
        ...state,
        IS_USING_MOBILE_APP: action.payload,
      };
    case SET_IGNORE_MOBILE_APP:
      return {
        ...state,
        IGNORE_MOBILE_APP: action.payload,
      };
    case SET_TOKEN:
      return {
        ...state,
        TOKEN: action.payload,
      };
    case SET_TOKEN_STATUS:
      return {
        ...state,
        TOKEN_STATUS: action.payload,
      };
    case SET_LOGIN_ID:
      return {
        ...state,
        LOGIN_ID: action.payload,
      };
    case SET_FRESHCHAT_UNREAD_COUNT:
      return {
        ...state,
        FRESHCHAT_UNREAD_COUNT: action.payload,
      };
    case SET_UPI_TRANSACTION_DATA:
      return {
        ...state,
        UPI_TRANSACTION_DATA: action.payload,
      };
    case SHOW_REFRESH_PAGE_POPUP:
      return {
        ...state,
        REFRESH_PAGE_POPUP: action.payload,
      };

    case UPDATE_ORDERS:
      return {
        ...state,
        REFRESH_ORDER: action.payload,
      };
    case FETCH_HISORIC_DATA:
      return action.payload;
    case ADD_FAV_PRICE:
      return {
        ...state,
        FAV_PRICES: [...state.FAV_PRICES, action.payload],
      };
    case DELETE_FAV_PRICE:
      return {
        ...state,
        FAV_PRICES: state.FAV_PRICES.filter((item) => item !== action.payload),
      };
    case SET_MOBILE_TAB:
      return {
        ...state,
        MOBILE_TAB: action.payload,
      };
    case SET_SELECTED_COIN:
      return {
        ...state,
        SELECTED_COIN: action.selectedCoin,
      };
    case SET_REFERRAL:
      return {
        ...state,
        REFERRAL: action.payload,
      };
    case SET_COIN_ICONS:
      return {
        ...state,
        COIN_ICONS: {
          ...state.COIN_ICONS,
          ...action.payload,
        },
      };
    case SET_INNOVATION_DO_NOT_SHOW:
      return {
        ...state,
        INNOVATION_DNS: { ...state.INNOVATION_DNS, ...action.payload },
      };
    case SET_ACC_POPUP:
      return {
        ...state,
        ACC_POPUP: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
